import { Chance } from "chance"
import { ExtractCategory } from "etl/types";

const chance = new Chance();

export const extractCategoryFactoryMock = (howMany: number): ExtractCategory[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/extract_categories/${index + 1}`,
		"@type": "ExtractCategory",
		id: index + 1,
		actif: chance.word(),
		libelle: chance.word(),
		aw_company_id: chance.integer().toString(),
		hb_id: chance.integer().toString()
	}));
